import { Link } from 'react-router-dom'
import { useSelector } from "react-redux"
import { RootState } from "@/lib/store/store"
import bevfedCircleLogo from "@/src/assets/bevfed-circle-logo.png";

export function Footer() {
  const { userType } = useSelector((state: RootState) => state.auth)
  const loggedIn = userType === "User"
  return (
    <footer className="border-t" style={{ background: 'var(--navy)', color: 'white' }}>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          {/* Logo & tagline */}
          <div className="space-y-4">
            <Link to={loggedIn ? "/catalog/" : "/"}>
              <img src={bevfedCircleLogo} alt="Beverage Federation" className="h-16 w-auto" />
            </Link>
            <p className="text-sm text-white/70 leading-relaxed">
              Your one-stop marketplace for everything craft beverage producers need.
            </p>
            <div className="flex gap-3 items-center">
              <a href="https://www.linkedin.com/company/beverage-federation/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label="LinkedIn">
                <svg preserveAspectRatio="xMidYMid" viewBox="0 0 256 256" className="w-5 h-5">
                  <path d="M218.123 218.127h-37.931v-59.403c0-14.165-.253-32.4-19.728-32.4-19.756 0-22.779 15.434-22.779 31.369v60.43h-37.93V95.967h36.413v16.694h.51a39.907 39.907 0 0 1 35.928-19.733c38.445 0 45.533 25.288 45.533 58.186l-.016 67.013ZM56.955 79.27c-12.157.002-22.014-9.852-22.016-22.009-.002-12.157 9.851-22.014 22.008-22.016 12.157-.003 22.014 9.851 22.016 22.008A22.013 22.013 0 0 1 56.955 79.27m18.966 138.858H37.95V95.967h37.97v122.16ZM237.033.018H18.89C8.58-.098.125 8.161-.001 18.471v219.053c.122 10.315 8.576 18.582 18.89 18.474h218.144c10.336.128 18.823-8.139 18.966-18.474V18.454c-.147-10.33-8.635-18.588-18.966-18.453" fill="currentColor" />
                </svg>
              </a>
              <a href="https://www.facebook.com/people/Beverage-Federation/100086632686981/" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label="Facebook">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/beveragefederation" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label="Instagram">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Shop</h3>
            <ul className="space-y-2.5">
              <li><Link to="/catalog/" className="text-sm text-white/70 hover:text-white transition-colors">Catalog</Link></li>
              <li><Link to="/food" className="text-sm text-white/70 hover:text-white transition-colors">Food Program</Link></li>
              <li><Link to="/craft-business-hub" className="text-sm text-white/70 hover:text-white transition-colors">Craft Business Hub</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-sm text-white/70 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/request-demo" className="text-sm text-white/70 hover:text-white transition-colors">Request a Demo</Link></li>
              <li><Link to="/faq" className="text-sm text-white/70 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Suppliers */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Suppliers</h3>
            <ul className="space-y-2.5">
              <li><Link to="/become-a-supplier" className="text-sm text-white/70 hover:text-white transition-colors">Become a Supplier</Link></li>
              <li><Link to="/portal/login" className="text-sm text-white/70 hover:text-white transition-colors">Partner Portal</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-2.5">
              <li><Link to="/terms-of-conduct-topics" className="text-sm text-white/70 hover:text-white transition-colors">Terms of Conduct</Link></li>
              <li><Link to="/privacy" className="text-sm text-white/70 hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-5 pt-3 text-center">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Beverage Federation. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
